import { render } from "./ConversationHeader.vue.js?vue&type=template&id=13bd9cbd!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationHeader.vue?vue&type=template&id=13bd9cbd"
import script from "./ConversationHeader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationHeader.vue?vue&type=script&lang=js"
export * from "./ConversationHeader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/ConversationHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13bd9cbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13bd9cbd', __exports__)) {
    api.reload('13bd9cbd', __exports__)
  }
  
  module.hot.accept("./ConversationHeader.vue.js?vue&type=template&id=13bd9cbd!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationHeader.vue?vue&type=template&id=13bd9cbd", () => {
    api.rerender('13bd9cbd', render)
  })

}


export default __exports__